<val-carte-dashboard [titre]="'dashboard.carte-suivi-regularisations-achat.titre' | transloco" [colonnes]="4" [lignes]="2"
	[chargementEnCours]="chargementEnCours" [estEnErreur]="estEnErreur">

	<ng-template>
	@if (donnees)
	{

	<div class="val-carte-suivi-regularisations">

		<div class="val-carte-suivi-regularisations-entete">
			<span class="val-carte-suivi-regularisations-badge">
				{{ donnees.nombreActionsRequises }}
			</span>
			<span class="val-carte-suivi-regularisations-libelle">
				{{ 'dashboard.carte-suivi-regularisations-achat.actions-requises.libelle' | transloco }}
			</span>
		</div>

		<div class="val-carte-suivi-regularisations-lignes">
			@if (donnees.nombreActionsRequises === 0)
			{
				<span class="val-carte-suivi-regularisations-vide">
					{{ 'dashboard.carte-suivi-regularisations-achat.actions-requises.aucune-donnee' | transloco }}
				</span>
			}
			@for (ligne of lignes; track ligne.cleLibelle)
			{
				@if (ligne.donnee.nombre > 0)
				{
				<button type="button" class="val-carte-suivi-regularisations-ligne"
					[style.--ligne-couleur-survol]="CalculerCouleurFond(ligne.donnee.couleurCode)"
					(click)="NaviguerVersFacturesAchat()">
					<span class="val-carte-suivi-regularisations-nombre" [style.color]="ligne.donnee.couleurCode ?? 'inherit'">{{ ligne.donnee.nombre }}</span>
					<span class="val-carte-suivi-regularisations-puce" [style.background-color]="ligne.donnee.couleurCode ?? 'transparent'"></span>
					<span class="val-carte-suivi-regularisations-ligne-libelle">{{ ligne.cleLibelle | transloco }}</span>
					<span class="val-carte-suivi-regularisations-montant" [style.color]="ligne.donnee.couleurCode ?? 'inherit'">
						{{ ligne.donnee.montantTtc | translocoCurrency }}
					</span>
				</button>
				}
			}
		</div>

	</div>

	}
	</ng-template>

</val-carte-dashboard>
